import { getListReportBalanceChangeMainAgentAPI, getListReportBalanceChangeMainAgentExcelAPI } from "../../../api/report";
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ParamsReport, ReportBalanceChange } from "../../../types/report";
import { Constant } from "../../../config/constant";
import { toast } from "react-toastify";

const limit_pagination: any = window.localStorage.getItem("limit_pagination");
const limitPagination = isNaN(Number(limit_pagination))
    ? Constant.PAGE_SIZE
    : Number(limit_pagination);

const initialState = {
    listReport: [],
    loading: false,
    pagination: {
        total: 0,
        per_page: limitPagination,
        current_page: Constant.DEFAULT_PAGE,
        last_page: Constant.DEFAULT_PAGE,
    },
    filter: {
        from: '',
        to: '',
        content: '',
    }
} as ReportBalanceChange;

export const reportBalanceChangeMainAgentSlice = createSlice({
    name: 'reportBalanceChangeMainAgent',
    initialState,
    reducers: {
        setFilterRangeDate(state, action: PayloadAction<any>) {
            state.filter.from = action.payload?.[0];
            state.filter.to = action.payload?.[1];
        },
        setFilterContent(state, action: PayloadAction<string>) {
            state.filter.content = action.payload;
        },
        setPerPage(state, action: PayloadAction<number>) {
            state.pagination.per_page = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getListReportBalanceChangeMainAgent.pending, (state) => {
                state.loading = true;
            }).addCase(getListReportBalanceChangeMainAgent.fulfilled, (state, action) => {
                state.loading = false;
                state.listReport = action?.payload?.data;
                state.pagination.total = action.payload?.pagination?.total;
                state.pagination.per_page = action.payload?.pagination?.per_page;
                state.pagination.last_page = action.payload?.pagination?.last_page;
                state.pagination.current_page = action.payload?.pagination?.current_page;

            }).addCase(getListReportBalanceChangeMainAgent.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach((fieldName) => {
                        toast.error(`${[listErros[fieldName]]}`);
                    });
                }
                state.loading = false;
            }).addCase(getListReportBalanceChangeMainAgentExcel.pending, (state) => {
            }).addCase(getListReportBalanceChangeMainAgentExcel.fulfilled, (state, action) => {
            }).addCase(getListReportBalanceChangeMainAgentExcel.rejected, (state, action: any) => {
                const listErros = action?.payload?.response?.data?.errors;
                if (listErros) {
                    Object.keys(listErros)?.forEach(fieldName => {
                        toast.error(`${[listErros[fieldName]]}`)
                    })
                }
            })
    }
})

export const getListReportBalanceChangeMainAgent = createAsyncThunk('ReportBalanceChangeMainAgent/getAll', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportBalanceChangeMainAgentAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const getListReportBalanceChangeMainAgentExcel = createAsyncThunk('ReportBalanceChangeMainAgent/getAllExcel', async (params: ParamsReport, {
    dispatch, rejectWithValue
}) => {
    try {
        const response = await getListReportBalanceChangeMainAgentExcelAPI(params)
        if (response) {
            return response?.data;
        }
    } catch (error: any) {
        return rejectWithValue(error);
    }
})

export const { setFilterRangeDate, setFilterContent, setPerPage } = reportBalanceChangeMainAgentSlice.actions;